import { clampTo, extractImageFrames } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const nvidiaConfigs: Record<string, WavespeedModelConfig> = {
    'nvidia/cosmos-3-super/image-to-video': {
        // https://wavespeed.ai/zh-CN/models/nvidia/cosmos-3-super/image-to-video
        apiPath: '/nvidia/cosmos-3-super/image-to-video',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, providerOptions } = params;
            const [firstImage] = extractImageFrames(imagePrompt);
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                duration: clampTo(duration || 7, [1, 2, 3, 4, 5, 6, 7] as const, 7),
                // 首帧 URL
                image: firstImage,
                // 可选参数
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                num_inference_steps: typeof providerOptions?.num_inference_steps === 'number' ? providerOptions.num_inference_steps : 28,
                guidance_scale: typeof providerOptions?.guidance_scale === 'number' ? providerOptions.guidance_scale : 6,
            };
        },
    },
};